import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const mealLogsApi = createApi({
  reducerPath: 'mealLogsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['MealLogs', 'DailySummary'],
  endpoints: (builder) => ({
    logMealFromRecipe: builder.mutation({
      query: (body) => ({
        url: 'meal-logs/recipe',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['MealLogs', 'DailySummary'],
    }),
    getDailySummary: builder.query({
      query: (date) => `meal-logs/daily/${date}`,
      providesTags: ['DailySummary'],
    }),
    getMealsForDateRange: builder.query({
      query: ({ startDate, endDate }) => `meal-logs?startDate=${startDate}&endDate=${endDate}`,
      providesTags: ['MealLogs'],
    }),
    deleteMeal: builder.mutation({
      query: (id) => ({
        url: `meal-logs/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MealLogs', 'DailySummary'],
    }),
  }),
});

export const {
  useLogMealFromRecipeMutation,
  useGetDailySummaryQuery,
  useGetMealsForDateRangeQuery,
  useDeleteMealMutation,
} = mealLogsApi;
